import { clear, show } from './methods'

export type { ToastShowProps } from './methods'
// UI：https://lanhuapp.com/web/#/item/project/detailDetach?pid=f0599670-81b5-4c85-a70a-b5441c72d4a8&project_id=f0599670-81b5-4c85-a70a-b5441c72d4a8&image_id=b5e778de-d745-474d-8b73-0da52106ba9c&fromEditor=true
// 参考：https://mobile.ant.design/components/toast
const Toast = {
  show,
  clear,
}

export default Toast